export const siteConfig = {
  name: '开元体育',
  tagline: '专业体育娱乐平台',
  description: '开元体育是您首选的专业体育娱乐平台，汇聚多元体育赛事、实时赔率与顶级竞技内容。安全、公平、流畅的在线体育体验。',
  url: 'https://www.kaiyuansports.com',
  logo: '开元体育',
  contact: {
    email: 'service@kaiyuansports.com',
    phone: '400-888-6688',
    address: '中国上海市浦东新区陆家嘴金融区',
    wechat: 'kaiyuansports',
    qq: '800123456',
  },
};

export const navLinks = [
  { name: '首页', href: '/', icon: 'ri-home-4-line' },
  { name: '赛事中心', href: '/category/sports', icon: 'ri-football-line' },
  { name: '体育资讯', href: '/category/news', icon: 'ri-newspaper-line' },
  { name: '优惠活动', href: '/category/promotions', icon: 'ri-gift-line' },
  { name: '关于我们', href: '/about', icon: 'ri-information-line' },
];

export const sportsCategories = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球顶级足球赛事，英超、西甲、欧冠等实时赔率',
    matchCount: 1280,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲联赛全覆盖，精彩赛事不间断',
    matchCount: 960,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: 'ATP、WTA巡回赛实时数据，大满贯赛事特别赔率',
    matchCount: 540,
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2等顶级电竞赛事盘口',
    matchCount: 720,
  },
  {
    slug: 'baseball',
    name: '棒球',
    icon: 'ri-billiards-line',
    description: 'MLB、日职棒等精彩棒球赛事',
    matchCount: 320,
  },
  {
    slug: 'other',
    name: '综合',
    icon: 'ri-trophy-line',
    description: '乒乓球、羽毛球、斯诺克等综合体育赛事',
    matchCount: 680,
  },
];

export const footerLinks = {
  快速导航: [
    { name: '首页', href: '/' },
    { name: '赛事中心', href: '/category/sports' },
    { name: '体育资讯', href: '/category/news' },
    { name: '关于我们', href: '/about' },
  ],
  热门分类: [
    { name: '足球', href: '/category/football' },
    { name: '篮球', href: '/category/basketball' },
    { name: '网球', href: '/category/tennis' },
    { name: '电竞', href: '/category/esports' },
  ],
  帮助中心: [
    { name: '新手指南', href: '/article/newbie-guide' },
    { name: '常见问题', href: '/article/faq' },
    { name: '存款提款', href: '/article/deposit-withdraw' },
    { name: '规则说明', href: '/article/rules' },
  ],
};